import {Injectable} from '@angular/core';
import {DroitBnbaccess, HebergementBnbaccess} from '../hebergement-bnbaccess.model';
import {Observable} from 'rxjs/Rx';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';

@Injectable()
export class DroitService {
    private resourceUrl = 'api/hebergements';

    constructor(private http: Http) {
    }

    queryDroits(hebergement: HebergementBnbaccess, typeDroit: string): Observable<DroitBnbaccess[]> {
        let options: BaseRequestOptions = new BaseRequestOptions();
        let params: URLSearchParams = new URLSearchParams();
        params.set('typeDroit', typeDroit);
        options.search = params;
        return this.http.get(`${this.resourceUrl}/${hebergement.id}/droits`, options).map((res: Response) => {
            return res.json();
        });
    }

    updateDroit(hebergement: HebergementBnbaccess, droit: DroitBnbaccess): Observable<DroitBnbaccess> {
        return this.http.put(`${this.resourceUrl}/${hebergement.id}/droits`, droit).map((res: Response) => {
            return res.json();
        });
    }

    createDroit(hebergement: HebergementBnbaccess, droit: DroitBnbaccess): Observable<DroitBnbaccess> {
        return this.http.post(`${this.resourceUrl}/${hebergement.id}/droits`, droit).map((res: Response) => {
            return res.json();
        });
    }

    deleteDroit(hebergement: HebergementBnbaccess, droit: DroitBnbaccess): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${hebergement.id}/droits/${droit.id}`);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/hebergement/droit/droit.service.ts